var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { preferencesService } from "../../preferences/PreferencesService";
import { LightSourceRenderable } from "./LightSourceRenderable";
import { LightSourceType } from "flavr-common";
import { AmbientLight } from "three";
import { mainScene } from "../mainScene";
import { RendererSystem } from "../renderer/RendererSystem";
export class LightSystem extends RendererSystem {
    constructor(rendererModule) {
        super(rendererModule, "LightSystem");
        this.ambientLight = new AmbientLight(0xffffff, preferencesService.getNumberPreferredValue("ambientLightingBrightness", 0));
        this.dynamicLightsEnabled = preferencesService.getPreferredValue("useDynamicLights", "on") === "on";
        mainScene.add(this.ambientLight);
        preferencesService.onPreferenceChanged.add((key, newValue) => __awaiter(this, void 0, void 0, function* () {
            if (key !== "useDynamicLights" && key !== "ambientLightingBrightness")
                return false;
            this.changeLightsourcesOnModels(key, newValue);
            return true;
        }));
    }
    changeLightsourcesOnModels(key, newValue) {
        const ambientBrightness = key === "ambientLightingBrightness" && newValue !== undefined ? newValue : preferencesService.getNumberPreferredValue("ambientLightingBrightness", 0);
        if (ambientBrightness !== undefined && key === "ambientLightingBrightness") {
            this.ambientLight.intensity = ambientBrightness;
            if (newValue !== undefined)
                return;
        }
        const settingsValue = key === "useDynamicLights" && newValue !== undefined ? newValue : preferencesService.getPreferredValue("useDynamicLights", "on");
        const isOn = settingsValue === "on";
        // Immer aktualisieren, damit neu angelegte LightSourceRenderables den richtigen Wert lesen
        this.dynamicLightsEnabled = isOn;
        for (const rendererModel of this.renderer.getRendererModels().values()) {
            const lsr = rendererModel.getFacetRenderer(LightSourceRenderable);
            if (lsr) {
                if (lsr.type !== LightSourceType.Ambient) {
                    lsr.updateVisibility(isOn, false);
                    lsr.enabled = isOn;
                }
            }
        }
    }
}
